module.exports = __webpack_public_path__ + "img/gc_country_flag_dk.9632a380.svg";